import * as categoryTypes from "../../actions/category/types";
import * as sectionTypes from "../../actions/section/types";
import { changeItemPosition } from "../../utils/positioning";

const initialState = {
  hasFetchError: false,
  isFetching: false,
  isLoaded: false,
  isMoving: false,
  list: [],
  page: 0,
  pageCount: 0,
  count: 0,
  savingId: null,
  successId: null,
};

export default function sections(state = initialState, action) {
  switch (action.type) {
    case sectionTypes.FETCH_SECTION_SECTIONS_REQUEST:
    case categoryTypes.FETCH_CATEGORY_SECTIONS_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true,
        hasFetchError: false,
      });
    }
    case sectionTypes.FETCH_SECTION_SECTIONS_SUCCESS:
    case categoryTypes.FETCH_CATEGORY_SECTIONS_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        isLoaded: true,
        list: action.sections,
        page: action.page,
        pageCount: action.pageCount,
        count: action.count,
      });
    }
    case sectionTypes.FETCH_SECTION_SECTIONS_FAILURE:
    case categoryTypes.FETCH_CATEGORY_SECTIONS_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false,
        isLoaded: false,
        hasFetchError: true,
      });
    }
    case sectionTypes.MOVE_ARTICLE_TO_SECTION_FAILURE: {
      return Object.assign({}, state, {
        savingId: null,
        list: state.list.map(section => {
          if (section.id === action.destinationSectionId) {
            return Object.assign({}, section, {
              article_count: section.article_count - 1,
            });
          }

          return section;
        }),
      });
    }
    case sectionTypes.MOVE_ARTICLE_TO_SECTION_REQUEST: {
      return Object.assign({}, state, {
        savingId: action.destinationSectionId,
        list: state.list.map(section => {
          if (section.id === action.destinationSectionId) {
            return Object.assign({}, section, {
              article_count: section.article_count + 1,
            });
          }

          return section;
        }),
      });
    }
    case sectionTypes.MOVE_ARTICLE_TO_SECTION_SUCCESS: {
      return Object.assign({}, state, {
        savingId: null,
        successId: action.destinationSectionId,
      });
    }
    case categoryTypes.POSITION_CATEGORY_SECTION_REQUEST:
    case sectionTypes.POSITION_SECTION_REQUEST: {
      return Object.assign({}, state, {
        isMoving: true,
        savingId: state.list[action.sourceIndex].id,
        successId: null,
        list: changeItemPosition(
          state.list,
          action.sourceIndex,
          action.destinationIndex
        ),
      });
    }
    case categoryTypes.POSITION_CATEGORY_SECTION_FAILURE:
    case sectionTypes.POSITION_SECTION_FAILURE: {
      return Object.assign({}, state, {
        isMoving: false,
        savingId: null,
        successId: null,
        list: changeItemPosition(
          state.list,
          action.destinationIndex,
          action.sourceIndex
        ),
      });
    }
    case categoryTypes.POSITION_CATEGORY_SECTION_SUCCESS:
    case sectionTypes.POSITION_SECTION_SUCCESS: {
      return Object.assign({}, state, {
        isMoving: false,
        savingId: null,
        successId: state.savingId,
      });
    }
    case sectionTypes.MOVE_SECTION_TO_SECTION_REQUEST: {
      return Object.assign({}, state, {
        isMoving: true,
        savingId: action.destinationSectionId,
        successId: null,
        list: state.list
          .filter(({ id }) => id !== action.movedSectionId)
          .map(section => {
            if (section.id === action.destinationSectionId) {
              return Object.assign({}, section, {
                section_count: section.section_count + 1,
              });
            }

            return section;
          }),
      });
    }
    case sectionTypes.MOVE_SECTION_TO_SECTION_SUCCESS: {
      return Object.assign({}, state, {
        isMoving: false,
        savingId: null,
        successId: action.destinationSectionId,
      });
    }
    case sectionTypes.MOVE_SECTION_TO_SECTION_FAILURE: {
      const newList = state.list.map(section => {
        if (section.id === action.destinationSectionId) {
          return Object.assign({}, section, {
            section_count: section.section_count - 1,
          });
        }

        return section;
      });

      newList.splice(action.sourceIndex, 0, action.item);

      return Object.assign({}, state, {
        isMoving: false,
        savingId: null,
        list: newList,
      });
    }

    case sectionTypes.MOVE_SECTION_TO_CATEGORY_REQUEST: {
      return Object.assign({}, state, {
        list: state.list.filter(({ id }) => id !== action.movedSectionId),
      });
    }

    case categoryTypes.MOVE_CATEGORY_SECTION_TO_TOP_REQUEST:
    case sectionTypes.MOVE_SECTION_TO_TOP_REQUEST: {
      const item = state.list[action.sourceIndex];
      return Object.assign({}, state, {
        isMoving: true,
        savingId: item.id,
        successId: null,
        list:
          state.page === 1
            ? changeItemPosition(state.list, action.sourceIndex, 0)
            : state.list.filter(section => section.id !== item.id),
      });
    }
    case categoryTypes.MOVE_CATEGORY_SECTION_TO_TOP_FAILURE:
    case sectionTypes.MOVE_SECTION_TO_TOP_FAILURE: {
      let newList;

      if (state.page === 1) {
        newList = changeItemPosition(state.list, 0, action.sourceIndex);
      } else {
        newList = [...state.list];
        newList.splice(action.sourceIndex, 0, action.item);
      }

      return Object.assign({}, state, {
        isMoving: false,
        savingId: null,
        successId: null,
        list: newList,
      });
    }
    case categoryTypes.MOVE_CATEGORY_SECTION_TO_TOP_SUCCESS:
    case sectionTypes.MOVE_SECTION_TO_TOP_SUCCESS: {
      return Object.assign({}, state, {
        isMoving: false,
        savingId: null,
        successId: state.savingId,
      });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sections/index.js